module.exports = __webpack_public_path__ + "static/media/standing-banner.42fcc01f.png";